export default __webpack_public_path__ + "static/media/car-wash.inline.0d770599.svg";